<template>
  <div class="patient-card--wrap">
    <div class="patient-card">
      <profile-preview-image
        :key="currentPatient.profileId + '-' + currentPatient.uuid + currentPatient.thumbnailUrl"
        :profileId="currentPatient.profileId"
        :uuid="currentPatient.uuid"
        :avatarSize="80"
        :avatarClasses="['patient-card__avatar--wrap', 'avatar', 'rounded']"
        :imageClasses="['patient-card__avatar']"
        :thumbnailUrl="currentPatient.thumbnailUrl"
      />
      <div class="patient-card__name--wrap">
        <p
          class="patient-card__name"
          v-if="currentPatient.firstName || currentPatient.lastName"
        >
          <span>{{ currentPatient.firstName }}</span>
          <span>{{
            currentPatient.lastName.length > 10
              ? currentPatient.lastName.substring(0, 1) + '.'
              : currentPatient.lastName
          }}</span>
        </p>
        <span class="patient-card__status">
          <i class="bh-dot bhYellowDark">&nbsp;</i>
          {{ currentPatient.isActive ? 'Active' : 'Inactive' }}
        </span>
      </div>
    </div>
    <span
      class="patient-card__last-login bhGray3--text"
      v-if="currentPatient.lastLoginDate"
    >
      Last login:
      <span class="bhBlack--text">{{
        $moment(currentPatient.lastLoginDate).format('MMM DD, YYYY hh:mm A')
      }}</span>
    </span>
    <span
      class="patient-card__last-activity bhGray3--text"
      v-if="currentPatient.lastActivity"
    >
      Last activity:
      <span class="bhBlack--text">{{
        $moment(currentPatient.lastActivity).format('MMM DD, YYYY hh:mm A')
      }}</span>
    </span>
  </div>
</template>

<script>
import ProfilePreviewImage from '../profile/ProfilePreviewImage.vue'
export default {
  components: { ProfilePreviewImage },
  name: 'PatientCard',
  data: () => ({}),
  computed: {
    getFullPath() {
      return this.$route.path
    },
    currentPatient: {
      get() {
        return this.$store.state.patientsStates.currentPatient
      },
      set(val) {
        this.$store.commit('patientsStates/updateCurrentPatient', val)
      },
    },
  },
}
</script>

<style lang="scss">
@import '@/styles/variables';

.patient-card {
  display: flex;

  &__avatar {
    border-radius: $border-radius-root2;

    &--wrap {
      display: flex;
      position: relative;
      margin-right: 16px;
      flex-shrink: 0;
      width: 80px;
      height: 80px;
      img {
        object-fit: cover;
        width: 100%;
        height: 100%;
      }
    }
  }

  &__name {
    font-size: 1.42857rem;
    line-height: 1;
    color: $bh-blue;
    font-weight: 700;
    span {
      display: block;
    }
    &--wrap {
      padding-top: 15px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-start;
      height: 100%;
    }
  }

  &__status {
    font-size: 0.85715rem;
    line-height: 1.16666667em;

    .bh-dot {
      margin-right: 8px;
    }
  }

  &__last-login {
    display: inline-block;
    width: 100%;
    font-size: 0.85715rem;
    line-height: 1.16666667em;
    padding: 20px 0 0;
  }
  &__last-activity {
    display: inline-block;
    width: 100%;
    font-size: 0.85715rem;
    line-height: 1.16666667em;
    padding: 5px 0 0;
  }
}
</style>
